<template>
	<div class="tree-box">
		<el-tree :data="data" class="tree-lists" :props="defaultProps" ref="tree"
			:render-after-expand="false" :load="loadNode" lazy node-key="id" :default-expanded-keys="[0]" @node-click="handleTreeClick">
			<div class="custom-tree-node" slot-scope="{ node, data }">
				<span v-if="node.data.type == '' || node.data.type == null">
					<i class="iconfont" :class="setIcon(node)"></i>
					{{ node.label }}
					<template v-if="hasOperate">
						<el-button type="text" size="mini" @click.stop="onAdd(node,data)">添加</el-button>
						<el-button type="text" size="mini" @click.stop="onEdit(node)"  v-show="node.data.id != 0">编辑</el-button>
						<el-button type="text" size="mini"  v-show="node.data.id != 0" @click.stop="onDelete(node)">删除</el-button> 
					</template>
				</span>
				<el-button @click.stop="toMore(node,data)" v-else-if="node.data.type =='more'" type="text" class="more-btn" :disabled="node.data.name !='更多'">{{node.data.name}}</el-button>
				<el-popover v-else placement="right" trigger="hover" width="300" popper-class="system-class">
						<text-message :content="data.content" v-if="node.data.type == 'text'"></text-message>
						<image-message :src="data.attachment.fileurl" v-if="node.data.type == 'image'"></image-message>
						<file-message :file="data.attachment" v-if="node.data.type == 'file'"></file-message>
						<video-message :src="data.attachment.url" v-if="node.data.type == 'video'"></video-message>
						<card-message :data="data"  v-if="node.data.type == 'news'" keys="other"></card-message>
						<link-message :data="data" v-if="node.data.type == 'link'"></link-message>
						<mini-program-message :data="data.miniProgram" v-if="node.data.type == 'miniprogrampage'" :isShowMoney="true"></mini-program-message>
						<span slot="reference">
							<i class="iconfont" :class="setIcon(node)"></i>
							{{ node.label }}
							<template v-if="hasOperate">
								<el-button type="text" size="mini" @click.stop="onEdit(node)"  v-show="node.data.id != 0">编辑</el-button>
								<el-button type="text" size="mini"  v-show="node.data.id != 0" @click.stop="onDelete(node)">删除</el-button> 
							</template>
						</span>
						
				</el-popover>
				
			</div>
		</el-tree>
		<addEditBox ref="addEditBox" @updateData="updateData"></addEditBox>
	</div>
</template>

<script>
	import addEditBox from './addEdit.vue'
	export default {
		props:{
			hasOperate:{
				default:false,
			},
			isRefresh:{
				default:false
			}
		},
		watch:{
			'isRefresh':{
				handler(val){
					if(val){
						this.data = [{
							name: "最外层文件夹",
							type:'',
							id:0,
							children:[]
						}]
						this.loadNode(this.chooseNode,this.resolveNode)
					}
				}
			}
		},
		components: {
			addEditBox,
		},
		data() {
			return {
				data: [{
						name: "最外层文件夹",
						type:'',
						id:0,
						children:[]
				}],
				defaultProps: {
					children: "children",
					label: "name",
					isLeaf: 'isLeaf'
				},
				listQuery:{
					id:0,
					pageNum:1,
					pageSize:10
				},
				chooseNode:'',
				resolveNode:'',
				morePageNum:1,
				moreTotal:0,
				searchVal:''
				
			}
		},
		methods: {
			toSearch(val){
				this.$refs.tree.$data.store.lazy = !val;
				this.searchVal = val;
				if(val){
					this.morePageNum = 1;
					this.data = [];
					this.getMoreData()
				}else {
					this.data = [{
						name: "最外层文件夹",
						type:'',
						id:0,
						children:[]
					}]
					this.loadNode(this.chooseNode,this.resolveNode)
				}	
			},
			getMoreData(){
				this.$api.searchSystemFastWordsLists(`/ocs-kdb/manager/search?keyword=${this.searchVal}&pageNum=${this.morePageNum}&pageSize=10`).then(res => {
					if(res.errcode == 0) {
						this.moreTotal = res.pages;
						let result = res.list.length > 0 ? this.data.concat(res.list) : this.data;
						if(this.morePageNum >= this.moreTotal){
							// this.data = result.concat([{
							// 	name:'没有更多数据咯',
							// 	type:'more',
							// 	isLeaf:true,
							// 	keys:'searchMore'
							// }])
							this.data = result;
							
						}else {
							this.data = result.concat([{
								name:'更多',
								type:'more',
								isLeaf:true,
								keys:'searchMore'
							}])
						}
					}
				})
			},
			handleTreeClick(data,node){
				this.$emit('handleTreeClick',data)
			},
			onAdd(node){
				this.$refs.addEditBox.onAdd(node)
			},
			onEdit(node){
				this.$refs.addEditBox.onEdit(node)
			},
			onDelete(node){
				let msg = node.data.type ? '确定删除吗？':'该操作会删除目录下的所有文件和子目录,确定删除吗？'
				this.$confirm(msg, '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  type: 'warning'
					}).then(() => {
					  this.$api.deleteSystemFastWordsListItem(node.data.id).then(res => {
						  if(res.errcode == 0){
							  this.$message.success('删除成功')
							  node.parent.loaded = false
							  node.parent.expand()
						  }
					  })
					}).catch(() => {
					  this.$message.warning('取消删除')         
					});
				
			},
			
			// 更新数据
			updateData(val){
				if(val.id){
					val.nodes.parent.loaded = false
					val.nodes.parent.expand()
				}else{
					val.nodes.loaded = false;
					val.nodes.expand();
				}
				
			},
			setIcon(node) {
				let icon = "";
				switch(node.data.type){
					case 'text':
						icon = 'major-text'
						break;
					case 'image':
						icon = 'major-tianchongxing-'
						break;
					case 'file':
						icon = 'major-files'
						break;
					case 'miniprogrampage':
						icon = 'major-xiaochengxu'
						break;
					case 'video':
						icon = 'major-lianxi2hebing_shipin'
						break;
					case 'voice':
						icon = 'major-Voice2'
						break;
					case 'news':
						icon = 'major-news'
						break;
					case 'link':
						icon = 'major-weixinxiaochengxu'
						break;
					default:
						icon = "major-ziyuan";
					
				}
				return icon;
			},
			getData(node){
				this.$api.getSystemFastWordsLists(this.listQuery).then(res => {
					if(res.errcode == 0) {
						let total =  parseInt((res.total + this.listQuery.pageSize - 1) / this.listQuery.pageSize);
						res.list.map(item => {
							if(item.type){
								item.isLeaf = true
							}
						})
						  node.data.lists.push(res.list)
						  let result = node.data.lists.flat()
							let more = [{
							 name: this.listQuery.pageNum - total < 0 ? '更多' : '没有更多数据咯',
							 type:'more',
							 total:total,
							 isLeaf:true,
							 pageNum:node.data.pageNum,
							 lists:node.data.lists
						 }]
						this.$refs.tree.remove(node);
						result = this.listQuery.pageNum - total < 0 ? result.concat(more) : result;
						this.$refs.tree.updateKeyChildren(this.listQuery.id,result)
					}
				})
			},
			toMore(node,data){
				// keys： searchMore 搜索得分页
				if(data.keys){
					this.morePageNum++
					if(this.morePageNum > this.moreTotal){
						this.morePageNum = this.moreTotal
					}else {
						this.data.splice(this.data.length - 1,1)
						this.getMoreData()
					}
				}else {
					data.pageNum++
					this.listQuery.id = node.parent.data.id
					if(data.pageNum - data.total > 0) {
						data.pageNum = data.total
						this.listQuery.pageNum = data.pageNum
					}else {
						this.listQuery.pageNum = data.pageNum
						this.getData(node)
					}
				}
				
			},
			loadNode(node, resolve){
				node.data.children = [];
				let more = [{
					name:'更多',
					type:'more',
					total:0,
					isLeaf:true,
					pageNum:1,
					lists:[]
				}]
				if (node.level == 0) {
					 this.chooseNode = node;
					 this.resolveNode = resolve
				     return resolve(this.data);
				}
				if(node.level >= 1){
					this.listQuery.id = node.data.id;
					this.listQuery.pageNum = 1;
					// this.listQuery.pageNum = node.childNodes.length > 0 ? node.childNodes[node.childNodes.length - 1].data.pageNum :  1
					this.$api.getSystemFastWordsLists(this.listQuery).then(res => {
						if(res.errcode == 0) {
							let total =  parseInt((res.total + this.listQuery.pageSize - 1) / this.listQuery.pageSize);
							more[0].name = this.listQuery.pageNum - total < 0 ? '更多' : '没有更多数据咯'
							more[0].total = total
							more[0].lists.push(res.list)
							res.list.map(item => {
								if(item.type){
									item.isLeaf = true
								}
							})
							if(this.listQuery.pageNum - total < 0 ) {
								return resolve(res.list.concat(more))
							}
							return resolve(res.list)
						}
					})
				}
			}
		},
		mounted() {
			// this.getData()
		}
	}
</script>

<style lang="scss">
	.tree-box {
		height: 100%;
		overflow-y: scroll;
		font-size: 14px;
		.major-ziyuan {
			color: #337EFF;
			font-size: 14px;
		}
		.more-btn {
			padding-left: 20px;
		}
		.system-class {
			
		}
	}
</style>
